import React, { useState } from 'react';
import { Box, Button, Dialog, Typography } from '@mui/material';
import { fontSize } from '../..';
import { databaseList } from './Data';
import { TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

interface DisplayDatabasesProps {
  canChangeDatabase?: boolean;
  onClick: (label: string, value: string) => void;
  selectedDb: string | null;
  hasModified?: boolean;
}
const DisplayDatabases = ({
  selectedDb,
  onClick,
  canChangeDatabase = true,
  hasModified = false,
}: DisplayDatabasesProps) => {
  const [confirmChange, setConfirmChange] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>('');

  const filterDatabaseList = databaseList.filter((db) =>
    db.name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        borderRight: '2px solid rgb(224,224,224)', // Uses theme's divider color by default
        flex: '0.15 1 0%',
        minWidth: 270,
        maxWidth: 480, // 30rem = 480px
        width: 'auto',
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
          width: '5px',
        },
      }}
    >
      <Typography
        variant="h6"
        sx={{
          paddingBlock: '0.5rem',
          //position: 'sticky',
          top: '0',
          fontSize: fontSize.extraLarge,
          fontWeight: 'bold',
          width: '100%',
          mb: 1,
        }}
      >
        {canChangeDatabase ? 'Select a Database' : 'Database'}
      </Typography>

      <Box sx={{ px: 2, pb: 2 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Search databases..."
          value={searchQuery}
          className="vendorSearch"
          onChange={(e) => setSearchQuery(e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <FontAwesomeIcon icon={faSearch} />
                </InputAdornment>
              ),
            },
          }}
        />
      </Box>

      <Box sx={{ px: 2 }}>
        {filterDatabaseList.length > 0 ? (
          filterDatabaseList.map((db) => (
            <Box
              onClick={() => {
                if (canChangeDatabase) {
                  if (!hasModified) onClick('vendor', db.value);
                  else setConfirmChange(db.value);
                }
              }}
              key={db.id}
              sx={{
                cursor: canChangeDatabase ? 'pointer' : 'not-allowed',
                outline: selectedDb === db.value ? '1px solid #af99db' : 'none',
                display: 'grid',
                gridTemplateColumns: '40px 1fr',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: 1,
                px: 2,
                py: 1,
                my: 0.5,
                pl: 1,
                transition: 'padding 0.3s ease',
                '&:hover': {
                  outline: '1px solid #e0e0e0',
                },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <img src={db.img} alt={db.name} className={`vendorIconStyle ${db.value}Icon`} />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  minWidth: 0, // Allow text to shrink
                }}
              >
                <Typography className={`db-name ${db.value}-text`}>{db.name}</Typography>
              </Box>
            </Box>
          ))
        ) : (
          <Typography sx={{ px: 2, py: 1, color: 'gray' }}>No databases found.</Typography>
        )}
      </Box>

      <Dialog open={!!confirmChange}>
        <div className="dbDeleteDialog" style={{ width: '400px' }}>
          <div className="dbDeleteDialogMsg">
            You are selecting a different database vendor.
            <br />
            Are you sure to reset connection details?
            <br />
            <br />
          </div>
          <div className="dbDeleteDialogBtnContainer">
            <Button
              className="dbDeleteDialogBtn1"
              variant="contained"
              sx={{
                backgroundColor: 'white',
                color: '#5d5c5c',
                border: '1px solid gray',
                marginLeft: '8px',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: 'gray',
                  color: 'white',
                },
              }}
              onClick={() => {
                setConfirmChange(null);
              }}
            >
              Cancel
            </Button>

            <Button
              className="dbDeleteDialogBtn2"
              sx={{
                backgroundColor: 'white',
                color: '#5d5c5c',
                border: '1px solid #af99db',
                marginRight: '6px',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: ' #af99db',
                  color: 'white',
                },
              }}
              variant="contained"
              onClick={() => {
                onClick('vendor', confirmChange!);
                setConfirmChange(null);
              }}
            >
              Continue
            </Button>
          </div>
        </div>
      </Dialog>
    </Box>
  );
};

export default DisplayDatabases;
